import { CSSProperties } from 'react';

const EXCLUDED_RIDESHARE_REPORT_CONTRACTORS = new Set([
  'unassigned',
  'rejected',
  'contractor rejected',
]);

export const isRideshareReportContractor = (label: string): boolean =>
  !EXCLUDED_RIDESHARE_REPORT_CONTRACTORS.has(label.trim().toLowerCase());

export const blurStyle = (isFetching?: boolean): CSSProperties =>
  isFetching
    ? {
        filter: 'blur(3px)',
        userSelect: 'none',
        pointerEvents: 'none',
      }
    : {};
